module.exports = __webpack_public_path__ + "static/media/corner.06cb60d7.svg";